import swal from 'sweetalert2';

document.querySelectorAll('[data-module-binding="workshop_combo"]').forEach(form => {
  const itemInput = form.querySelector('input[name="item_event_combo"]');
  const eventPackageList = form.querySelector('.event-package-list');
  const eventChoices = form.querySelectorAll('input[name^="item_combo_event_"][data-event]');
  const eventChoicesArray = Array.from(eventChoices);
  const for2 = Number.parseFloat(itemInput.getAttribute('data-discountFor2'));
  const for3 = Number.parseFloat(itemInput.getAttribute('data-discountFor3'));
  const for4 = Number.parseFloat(itemInput.getAttribute('data-discountFor4'));
  const for5 = Number.parseFloat(itemInput.getAttribute('data-discountFor5'));

  function getChecked() {
    return eventChoicesArray.filter(input => input.checked);
  }

  $(eventChoices).on('change', event => {
    const checked = getChecked();

    if (checked.length) {
      $(eventPackageList).fadeIn();
    } else {
      $(eventPackageList).hide();
    }

    eventChoicesArray.forEach(eventChoice => {
      const packageChoiceRow = form.querySelector(`.event-package-choice[data-event="${eventChoice.getAttribute('data-event')}"]`);
      const packageChoice = form.querySelector(`input[name^="item_event_package_"][data-event="${eventChoice.getAttribute('data-event')}"]`);
      if (packageChoiceRow) {
        if (eventChoice.checked) {
          $(packageChoiceRow).fadeIn();
        } else {
          $(packageChoiceRow).hide();
        }
      }
      if (packageChoice) {
        packageChoice.disabled = !eventChoice.checked;
      }
    });
  }).trigger('change');

  $(form).submit(event => {
    const checked = getChecked();

    if (checked.length >= 2) {
      let totalPrice = 0,
        discount = 0;

      for (const eventChoice of checked) {
        totalPrice += Number.parseFloat(eventChoice.getAttribute('data-price'));
      }
      if (checked.length === 2) {
        discount = (for2 > 0.00) ? for2 : 50;
      } else if (checked.length === 3) {
        discount = (for3 > 0.00) ? for3 : 70;
      } else if (checked.length === 4) {
        discount = (for4 > 0.00) ? for4 : 227;
      } else {
        discount = (for5 > 0.00) ? for5 : 227;
      }
      totalPrice -= discount;
      itemInput.value = itemInput.value.replace(/^([^\^]+\^[^\^]+\^[^\^]+\^)[^\^]+(.+)$/s, `$1${totalPrice}$2`);
    } else {
      event.preventDefault();
      event.stopPropagation();
      swal({
        type: 'error',
        text: "Please select more than one event to take advantage of the combo discount.",
      });
    }
  });
});